import {EntityField} from "../../core/genericdocuments/EntityField"
import {EntityFieldDataType} from "../../core/genericdocuments/EntityFieldDataType"
import {EntityFieldsDescriptor} from "../../core/genericdocuments/EntityFieldsDescriptor"
import {LookupEntities} from "../../core/genericdocuments/ReferenceDetails"
import {Customer} from "../../models/Customer"

export const customerFields: IntercateKeysMap<Customer, EntityField<Customer>> = {
    id: {
		name: "id", dataType: EntityFieldDataType._string, label: "Id klijenta",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    title: {
		name: "title", dataType: EntityFieldDataType._string, label: "Naziv / Ime i prezime",
		validator: { required: true },
		sortable: true,
		filterable: true
	},
    vatId: {
		name: "vatId", dataType: EntityFieldDataType._number, label: "PIB / JMBG",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    companyId: {
		name: "companyId", dataType: EntityFieldDataType._number, label: "Matični broj",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    internalId: {
		name: "internalId", dataType: EntityFieldDataType._number, label: "Interna šifra",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    email: {
		name: "email", dataType: EntityFieldDataType._string, label: "Email",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    address: {
		name: "address", dataType: EntityFieldDataType._string, label: "Adresa",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    business: {
		name: "business", dataType: EntityFieldDataType._string, label: "Delatnost",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    phone: {
		name: "phone", dataType: EntityFieldDataType._string, label: "Telefon",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    representative: {
		name: "representative", dataType: EntityFieldDataType._string, label: "Kontakt osoba",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    webAddress: {
		name: "webAddress", dataType: EntityFieldDataType._string, label: "Web stranica",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    saldo: {
		name: "saldo", dataType: EntityFieldDataType._number, label: "Saldo",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
    contacts: {
		name: "contacts", dataType: EntityFieldDataType._reference, label: "Kontakt",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Contacts
		},
		validator: { required: false },
		sortable: true
	},
}

const customerFieldsArray: Array<EntityField<Customer>> = [
	customerFields.title,
	customerFields.vatId,
	customerFields.companyId,
    customerFields.internalId,
    customerFields.email,
    customerFields.address,
    customerFields.business,
    customerFields.phone,
    customerFields.representative,
    customerFields.webAddress,
]

export const customerFieldsDescriptor: EntityFieldsDescriptor<Customer> = {
	listFields: customerFieldsArray,
	createFormFields: customerFieldsArray,
	updateFormFields: customerFieldsArray
}